"use strict";import{defineElement as e}from"@spectrum-web-components/base/src/define-element.js";import{TabPanel as a}from"./src/TabPanel.js";e("sp-tab-panel",a);
//# sourceMappingURL=sp-tab-panel.js.map
